import React from "react";

interface FieldErrorProps {
  message?: string;
}

const FieldError: React.FC<FieldErrorProps> = ({ message }) =>
  message ? (
    <div style={{ color: "#ef4444", fontSize: 12, marginTop: 4 }}>
      <i className="ti ti-alert-circle me-1" />
      {message}
    </div>
  ) : null;

export default FieldError;
